exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body #intercom-container .intercom-borderless-frame{bottom:105px}body #intercom-container .intercom-messenger-frame{bottom:115px}#launcher-intercom{width:126px;height:121px;max-width:27vw;max-height:32vw;position:fixed;z-index:10001;display:none;right:0;bottom:0;background-image:url(" + require("../images/ico-chat-sprite_valentine.png") + ");background-repeat:no-repeat;-ms-background-size:cover;background-size:cover}#launcher-intercom.open{background-position:-126px 0;animation:intercomOpacity 1s linear}@keyframes intercomOpacity{0%{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}to{-ms-filter:none;filter:none;opacity:1}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/css-loader?minimize!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/autoprefixer-loader?{browsers:["last 3 versions"],cascade:false}!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/stylus-loader??ref--6-3!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/intercom/stylus/_intercom.styl
// module id = 58
// module chunks = 5